import * as React from "react"
import { useTheme } from "styled-components"
import { t } from "ttag"
import { Icon } from "@humanpredictiveintelligence/myqvt-library"

import { Scheduled_Survey_Status as ScheduledSurveyStatus } from "models/generated"
import { CustomSurveyStatus } from "models/Survey"
import * as Styles from "./SurveyStatus.styles"

/**
 * Get the status label and icon to display for the survey
 */
export const SurveyStatus: React.FC<SurveyStatusProps> = (props) => {
  const theme = useTheme()

  const statusesMap = {
    [ScheduledSurveyStatus.Done]: {
      color: theme.colors.success,
      icon: "done",
      title: t`Closed`,
    },
    [ScheduledSurveyStatus.Ongoing]: {
      color: theme.colors.secondary,
      icon: "autorenew",
      title: t`Ongoing`,
    },
    [ScheduledSurveyStatus.Todo]: {
      color: theme.colors.blackMedium,
      icon: "date_range",
      title: t`Scheduled`,
    },
    [CustomSurveyStatus.Valid]: {
      color: theme.colors.success,
      icon: "verified",
      title: t`Validated`,
    },
    [CustomSurveyStatus.Used]: {
      color: theme.colors.blackMedium,
      icon: "lock",
      title: t`Used`,
    },
  }

  const status = statusesMap[props.status]

  return (
    <Styles.StatusWrapper>
      {!props.isCompact && <Styles.StatusTitle>{status.title}</Styles.StatusTitle>}
      <Icon
        size={props.isCompact ? 16 : undefined}
        name={status.icon}
        color={status.color}
      />
    </Styles.StatusWrapper>
  )
}

type Status = ScheduledSurveyStatus | CustomSurveyStatus

interface SurveyStatusProps {
  status: Status,
  isCompact?: boolean,
}
